






































































import Vue from 'vue';
import { mapState } from 'vuex';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import Header from '@/components/Header.vue';

export default Vue.extend({
  components: {
    pxCard,
    Header,
    pxButton,
    Loading,
    PlusIcon,
    CloseIcon,
  },

  data() {
    return {
      loaded: true,
      userEmail: '',
      addingAdmin: false,
      searchingUser: false,
      searched: false,
    };
  },

  computed: {
    ...mapState({
      admins: (state: any) => state.users.admins,
      searchedUsers: (state: any) => state.users.searchedUsers,
    }),
  },

  async created() {
    this.loaded = false;
    await this.$store.dispatch('PULL_ADMINS');
    this.loaded = true;
  },

  methods: {
    removeAdmin: async function(admin: any, index: number) {
      if (
        confirm(
          'Tem certeza que deseja retirar a permissão de admin do usuário ' +
            admin.name +
            '?',
        )
      ) {
        let response = await this.$store.dispatch('REMOVE_ADMIN', admin.id);

        if (response === true) {
          this.$store.commit('REMOVE_ADMIN', index);
          admin.role = 'user';
        } else {
          alert('Você não pode alterar a permissão desse admin!');
        }
      }
    },

    addAdmin: async function(user: any) {
      if (
        confirm(
          'Tem certeza que deseja dar a permissão de admin ao usuário ' +
            user.name +
            '?',
        )
      ) {
        this.addingAdmin = true;
        let response = await this.$store.dispatch('ADD_ADMIN', user.id);
        this.addingAdmin = false;

        if (response === true) {
          this.$store.commit('ADD_ADMIN', user);
          user.role = 'admin';
        } else {
          alert('Você não pode alterar a permissão desse usuário!');
        }
      }
    },

    searchUser: async function() {
      if (this.userEmail.length > 0) {
        this.searchingUser = true;
        await this.$store.dispatch('SEARCH_USER', this.userEmail);
        this.searchingUser = false;
        this.searched = true;
      }
    },
  },
});
